import { esFallaDeConexion, mensajeDeError } from '@/lib/api'

/**
 * Lo que se le dice al cajero cuando el cobro no llegó a viajar.
 *
 * «No se pudo registrar la venta» es media verdad y la mitad que falta es la
 * que importa: puede haberse guardado y haberse cortado la RESPUESTA. Sin
 * decirlo, el cajero no sabe si volver a apretar Cobrar o cargar todo de nuevo,
 * y las dos salidas están mal —una duplica la plata del arqueo si no hubiera
 * clave de idempotencia, la otra pierde la venta—. Como la clave va pegada al
 * ticket (o al monto tipeado, en la pantalla de solo cobro), reintentar es
 * SIEMPRE la respuesta correcta y se puede prometer que no duplica.
 *
 * Está en su propio archivo porque lo usan las DOS pantallas que cobran, y este
 * mensaje es de las cosas que no pueden decir dos cosas distintas según de qué
 * pantalla salió el error.
 */
export function mensajeDeCobro(e: unknown, porDefecto: string): string {
  if (esFallaDeConexion(e)) {
    return 'No pudimos comunicarnos con el sistema. Revisá la conexión y volvé a apretar Cobrar: si la venta ya se había registrado, no se duplica.'
  }

  return mensajeDeError(e, porDefecto)
}
